import { Injectable } from '@angular/core';
import { ServiceLibrary, ServiceReturn } from '@common_libraries/helpers/ServiceLibrary';
import { Observable } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';

@Injectable({providedIn: 'root'})
export class OktaActivationService {

  public constructor(private servLib: ServiceLibrary ) { }

  VerifyPersonActivation(activationGuid: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/User/VerifyPersonActivation/' + activationGuid, ServiceLibrary.ContentType.JSON, parameters);
  }

  PersonActivate(activationGuid: string, password: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('activationGuid', activationGuid);
    parameters.add('password', password);

    return this.servLib.HttpPost('/v1/api/User/PersonActivate', ServiceLibrary.ContentType.JSON, parameters);
  }

  ResendActivation(Email: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('Email', Email);

    return this.servLib.HttpPost('/v1/api/User/ResendActivation', ServiceLibrary.ContentType.JSON, parameters);
  }
}